<template>
    <div class="TheTablePaging">
        <div class="TheTablePaging__pager">

            <!--PREVIOUS-->
            <i class="icon-left-open-1 TheTablePaging__button" @click="previousPage" v-if="canDecrease"></i>
            <i class="icon-left-open-1 TheTablePaging__disabled" v-else></i>

            <!--CURRENT ITEMS INDEXES-->
            {{start}} - {{end}}

            <!--NEXT-->
            <i class="icon-right-open-1 TheTablePaging__button" @click="nextPage" v-if="canIncrease"></i>
            <i class="icon-right-open-1 TheTablePaging__disabled" v-else></i>

        </div>

        <!--TOTAL-->
        <div class="TheTablePaging__count">{{totalCount}} <span class="TheTablePaging__found">{{translate('TABLE__FOUND')}}</span></div>
    </div>
</template>

<script>
    import { mapActions, mapState } from 'vuex';

    export default {
        name: 'TheTablePaging',
        computed: {
            ...mapState({
                start: s => s.table.start,
                end: s => s.table.end,
                canDecrease: s => s.table.canDecrease,
                canIncrease: s => s.table.canIncrease,
                totalCount: s => s.table.totalCount
            })
        },
        methods: {
            ...mapActions({
                previousPage: 'table/previousPage',
                nextPage: 'table/nextPage'
            })
        }
    };
</script>

<style>
    .TheTablePaging {
        overflow: hidden;
        display: flex;
        flex-direction: row;
        align-items: center;
        margin: 8px;
    }

    .TheTablePaging__disabled {
        color: rgba(0,0,0,0.2);
    }

    .TheTablePaging__pager {
        color: rgba(0,0,0,1);
        font-size: 14px;
        font-weight: 500;
        user-select: none;
    }

    .TheTablePaging__button {
        cursor: pointer;
    }

    .TheTablePaging__count {
        flex: 1 1 auto;
        color: rgba(0,0,0,1);
        font-size: 14px;
        font-weight: 500;
        text-align: right;
    }

    @media (max-width: 600px) {
        .TheTablePaging__found {
            display: none;
        }
    }
</style>



// WEBPACK FOOTER //
// TheTablePaging.vue?40f85f22